const Firma = resolve => {
    require.ensure(['../views/apps/firma/Firma'], () => {
        resolve(require('../views/apps/firma/Firma'))
    })
};
const FirmaKayit = resolve => {
    require.ensure(['../views/apps/firma/FirmaKayit'], () => {
        resolve(require('../views/apps/firma/FirmaKayit'))
    })
};
const FirmaDetay = resolve => {
    require.ensure(['../views/apps/firma/FirmaDetay'], () => {
        resolve(require('../views/apps/firma/FirmaDetay'))
    })
};
const YoneticiTanimla = resolve => {
    require.ensure(['../views/apps/firma/YoneticiTanimla'], () => {
        resolve(require('../views/apps/firma/YoneticiTanimla'))
    })
};
const YoneticiListesi = resolve => {
    require.ensure(['../views/apps/firma/YoneticiListesi'], () => {
        resolve(require('../views/apps/firma/YoneticiListesi'))
    })
};
const YoneticiDuzenle = resolve => {
    require.ensure(['../views/apps/firma/YoneticiDuzenle'], () => {
        resolve(require('../views/apps/firma/YoneticiDuzenle'))
    })
};
import Vue from 'vue'
Vue.component('FirmaKayit', FirmaKayit);
Vue.component('FirmaDetay', FirmaDetay);
Vue.component('YoneticiTanimla', YoneticiTanimla);
Vue.component('YoneticiDuzenle', YoneticiDuzenle);
Vue.component('YoneticiListesi', YoneticiListesi);
import layouts from '../layout'

export default {
    path: '/firma',
    name: 'firma',
    component: Firma,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'firmatanimlama',
            component: FirmaKayit,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'detay',
            name: 'firmadetay',
            component: FirmaDetay,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'yoneticitanimlama',
            name: 'firmayoneticitanimla',
            component: YoneticiTanimla,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'yoneticiListesi',
            name: 'firmayoneticilistesi',
            component: YoneticiListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }, {
            path: 'yoneticiGuncelle',
            name: 'firmayoneticiguncelle',
            component: YoneticiDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        }
    ]
}
